import React, { Key, useEffect, useState } from 'react'
import './Users.scss'
import { useParams } from 'react-router-dom'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import employeeService from 'Services/employeeService'

import { HorizontalLoader, ModalWrapper, Pagination } from 'Components'
import { useForm } from 'react-hook-form'
import { TimeConverter } from 'Helpers/TimeConverter'
import Swal from 'sweetalert2'

export interface kpiType {
  id: number
  userId: string
  metric: string
  relevance: number
  createdAt: string
}
const KpiManagerLogAdmin = () => {
  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }
  const [showEditModal, setShowEditModal] = useState(false)

  const toggleEditModal = () => {
    setShowEditModal((prevState) => !prevState)
  }
  const [selected, setSelected] = useState<any>(null)

  const { showAlert } = ShowTGAlert()

  const [pageNumber, setPage] = useState(1)
  const [kpi, setKpi] = useState<
    {
      id: number
      userId: string
      metric: string
      relevance: number
      createdAt: string
    }[]
  >()

  const [loading, setLoading] = useState(false)
  const [request, setRequest] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [sortOrder, setSortOrder] = useState('DESC')
  const { userId } = useParams<{ userId: string }>()

  const getUserKpi = async () => {
    setLoading(true)
    await employeeService.kpiIndex(userId).then(
      (response) => {
        // console.log('employeeService', response?.data)
        setLoading(false)

        const dataSet = response?.data.data
        setKpi(dataSet)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })

        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getUserKpi()
  }, [pageNumber, sortOrder])

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<{ relevance: number; metric: string }>()

  const totalRelevance: any = kpi?.reduce((sum, item) => sum + Number(item.relevance || 0), 0)
  const remainingRelevance = 100 - totalRelevance

  const submit = handleSubmit(async (data) => {
    const total = totalRelevance + Number(data.relevance || 0)
    if (total >= 100) {
      showAlert({
        message: 'KPI can not exceed 100%',
        show: true,
        title: 'Error',
        type: 'error',
      })
      toggleModal()
      return
    }
    setRequest(true)
    await employeeService
      .kpiCreate({ relevance: data.relevance, metric: data.metric, userId })
      .then(
        async (response) => {
          // console.log('r', response)
          reset()
          setRequest(false)
          await getUserKpi()
          toggleModal()

          showAlert({
            message: 'KPI created succesfully',
            show: true,
            title: 'Done',
            type: 'success',
          })
        },
        (error: { response: { data: { error: string } } }) => {
          toggleModal()
          showAlert({
            message: error.response.data.error,
            show: true,
            title: 'Error',
            type: 'error',
          })

          setRequest(false)
        },
      )
  })

  const submitEdit = handleSubmit(async (data) => {
    const total = totalRelevance + Number(data.relevance || 0)
    if (total >= 100) {
      showAlert({
        message: 'KPI can not exceed 100%',
        show: true,
        title: 'Error',
        type: 'error',
      })
      toggleEditModal()
      return
    }
    setRequest(true)
    await employeeService
      .kpiUpdate({ relevance: data.relevance, metric: data.metric, id: selected.id })
      .then(
        async (response) => {
          // console.log('r', response)
          setRequest(false)
          await getUserKpi()
          toggleEditModal()

          showAlert({
            message: 'KPI updated succesfully',
            show: true,
            title: 'Done',
            type: 'success',
          })
        },
        (error: { response: { data: { error: string; message: string } } }) => {
          toggleEditModal()
          showAlert({
            message: error.response.data.error || error.response.data.message,
            show: true,
            title: 'Error',
            type: 'error',
          })

          setRequest(false)
        },
      )
  })

  const deleteKpi = async (id: number) => {
    setRequest(true)
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won&rsquo;t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result: { isConfirmed: boolean }) => {
      if (result.isConfirmed) {
        await employeeService.kpiDelete(id).then(
          async (response) => {
            setRequest(false)
            await getUserKpi()

            showAlert({
              message: 'KPI deleted succesfully',
              show: true,
              title: 'Done',
              type: 'success',
            })
          },
          (error: { response: { data: { error: string } } }) => {
            toggleModal()
            showAlert({
              message: error.response.data.error,
              show: true,
              title: 'Error',
              type: 'error',
            })

            setRequest(false)
          },
        )
      }
    })
  }

  const EditKpi = async (data: any) => {
    try {
      // setRequest(true)
      setSelected(data)
      toggleEditModal()

      reset({
        relevance: data.relevance,
        metric: data.metric,
      })
    } catch (error: any) {
      showAlert({
        message: error.response.data.error,
        show: true,
        title: 'Error',
        type: 'error',
      })
    }
  }

  return (
    <div className='Users'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-6 col-md-6 my-auto'>
                  <div className='title'>KPI Matrix</div>
                </div>
                <div className='col-12 col-sm-6 text-sm-end'>
                  <button className='btn btn-add-company' onClick={toggleModal}>
                    <svg
                      width='17'
                      height='17'
                      viewBox='0 0 20 20'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M13.5 9.5625H4.5C4.1925 9.5625 3.9375 9.3075 3.9375 9C3.9375 8.6925 4.1925 8.4375 4.5 8.4375H13.5C13.8075 8.4375 14.0625 8.6925 14.0625 9C14.0625 9.3075 13.8075 9.5625 13.5 9.5625Z'
                        fill='white'
                      />
                      <path
                        d='M9 14.0625C8.6925 14.0625 8.4375 13.8075 8.4375 13.5V4.5C8.4375 4.1925 8.6925 3.9375 9 3.9375C9.3075 3.9375 9.5625 4.1925 9.5625 4.5V13.5C9.5625 13.8075 9.3075 14.0625 9 14.0625Z'
                        fill='white'
                      />
                    </svg>
                    Add New KPI
                  </button>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div
                className={`kpi-weight-status ${kpi && kpi.length === 0 && 'd-none'} ${
                  remainingRelevance > 0
                    ? 'kpi-weight-status-warning'
                    : remainingRelevance === 0
                      ? 'kpi-weight-status-success'
                      : ''
                }`}
              >
                <>
                  <span className='kpi-weight-status-label'>Weight allocation</span>

                  <span className='kpi-weight-status-value'>
                    {remainingRelevance > 0 ? (
                      <>
                        <strong>{remainingRelevance}%</strong> weight left to allocate
                      </>
                    ) : remainingRelevance === 0 ? (
                      <>
                        <strong>100%</strong> weight allocated
                      </>
                    ) : (
                      <>
                        Weight exceeds 100% by <strong>{Math.abs(remainingRelevance)}%</strong>
                      </>
                    )}
                  </span>
                </>
              </div>

              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Matrix</td>
                      <td>Weight</td>
                      <td>Date Created</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {kpi &&
                      kpi.length > 0 &&
                      kpi.map((data: kpiType, index: Key) => (
                        <tr key={index}>
                          <td className='accountIdCol'>{Number(index) + 1}</td>
                          <td>{data.metric}</td>
                          <td>{data.relevance}%</td>
                          <td>{TimeConverter(data.createdAt)}</td>

                          <td className='dropdown option-dropdown'>
                            <button
                              className='btn btn-link text-danger'
                              onClick={() => deleteKpi(data.id)}
                            >
                              Delete
                            </button>
                            <button
                              className='btn btn-link text-secondary'
                              onClick={() => EditKpi(data)}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))}
                    {loading === false && kpi?.length === 0 && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          No kpi found
                        </td>
                      </tr>
                    )}
                    {loading === true && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationData.total >= paginationData.pageSize && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  {paginationData.total && (
                    <Pagination
                      className='pagination-bar ps-0'
                      currentPage={Number(paginationData.pageNumber)}
                      totalCount={paginationData.total}
                      pageSize={paginationData.pageSize}
                      onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Add New KPI'>
        <form onSubmit={submit}>
          <div className='form-group mt-2'>
            <label htmlFor='relevance'>Weight</label>
            <select
              className='form-control'
              {...register('relevance', {
                required: 'This field can not be empty',
              })}
            >
              <option value={''}>Select weight</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
              <option value={60}>60</option>
              <option value={70}>70</option>
              <option value={80}>80</option>
              <option value={90}>90</option>
              <option value={100}>100</option>
            </select>
          </div>
          {errors.relevance && <small className='text-danger'>{errors.relevance.message}</small>}
          <div className='form-group mt-2'>
            <label htmlFor='metric'>Metric</label>
            <input
              placeholder='KPI Details'
              type='text'
              className='form-control'
              {...register('metric', {
                required: 'This field can not be empty',
              })}
            />
          </div>
          {errors.metric && <small className='text-danger'>{errors.metric.message}</small>}
          <div className='form-group mt-3'>
            <button
              type='submit'
              className='btn btn-default kpi-btn w-100'
              disabled={totalRelevance >= 100 ? true : false}
            >
              Create
              {request && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper showModal={showEditModal} closeModal={toggleEditModal} title='Edit KPI'>
        <form onSubmit={submitEdit}>
          <div className='form-group mt-2'>
            <label htmlFor='relevance'>Weight</label>
            <select
              className='form-control'
              {...register('relevance', {
                required: 'This field can not be empty',
              })}
            >
              <option value={''}>Select weight</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
              <option value={60}>60</option>
              <option value={70}>70</option>
              <option value={80}>80</option>
              <option value={90}>90</option>
              <option value={100}>100</option>
            </select>
          </div>
          {errors.relevance && <small className='text-danger'>{errors.relevance.message}</small>}
          <div className='form-group mt-2'>
            <label htmlFor='metric'>Metric</label>
            <input
              placeholder='KPI Details'
              type='text'
              className='form-control'
              {...register('metric', {
                required: 'This field can not be empty',
              })}
            />
          </div>
          {errors.metric && <small className='text-danger'>{errors.metric.message}</small>}
          <div className='form-group mt-3'>
            <button type='submit' className='btn btn-default kpi-btn w-100'>
              Edit
              {request && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default KpiManagerLogAdmin
